import { acceptedFileTypes, } from '../../utils/helper';
import { connect } from 'react-redux';
import { delay } from '../../utils/helper';
import { deleteFile, sendDocumentsToCM,} from '../../actions/lsRequestAction';
import { ExclamationPointDiamondIcon,} from '../../services/SvgLibrary';
import { getFileAndDownload } from '../../actions/fileDownloadAction';
import { LsFields } from '../../services/LsFields';
import { rolesUnderCouncilMembers,} from '../../services/constants';
import React, { useState, useEffect } from 'react';
import TagsDisplay from '../report-tracking/TagsDisplay';
import File from '../library/File';
import Modal from 'react-modal';
import styles from '../../styles/ls-request/UpdateLsRequestPopup.module.scss';
import ToolTip from '../library/ToolTip';

const SendToCMPopup = props => {
  /*  States  */
  const [curtLs, setCurtLs] = useState({
    bill: props.updateTargetLs.bill,
    legal_memo: props.updateTargetLs.legal_memo,
    ls_number: props.updateTargetLs.ls_number,
    ls_type:  props.updateTargetLs.ls_type,
    plain_language_summary: props.updateTargetLs.plain_language_summary,
    overlapping_ls: props.updateTargetLs.overlapping_ls,
  });
  const [errorField, setErrorField] = useState({});
  const [errorMessage, setErrorMessage] = useState([]);
  const filteredFields = structuredClone(LsFields).filter(
    field => {
      if (['legal_memo', 'plain_language_summary', 'bill', 'overlapping_ls'].includes(field.field)) {
        if (field.field === 'bill') {
          field.required = true;
        }
        return field
      }
    }
  )
  const [newFields, setNewFields] = useState({
    bill: [],
    legal_memo: [],
    plain_language_summary: [],
  });
  /* End states */

  /**
   * useEffect hook for component mount
   */
  useEffect(() => {
    Modal.setAppElement('body');
  }, []);
  /** End component mount useEffect hook */

  const scrollToTheTop = () => {
    document
      .getElementsByClassName(styles['update-ls-request-body'])[0]
      .scrollTo(0, 0);
  };

  const checkValidation = () => {
    let correctInput = true;
    let lsArr = filteredFields;
    let errors = {};
    let errorArray = [];

    for (let i = 0; i < lsArr.length; i++) {
      // Make sure the file is a docx file
      let value = ''
      if (lsArr[i].type == "file") {
        if (newFields[lsArr[i].field].length > 0) {
          newFields[lsArr[i].field].forEach(file => {
            if(!file.file_name.endsWith('.docx')) {
              correctInput = false;
              errorArray.push(lsArr[i].title);
              errors[lsArr[i].field] = 'Files must be in a docx format!';
            }
          });
        }
        value = [curtLs[lsArr[i].field]] + [newFields[lsArr[i].field]];
      } else {
        value = curtLs[lsArr[i].field];
      }

      // If the Ls Type is Resolution only Bills are required otherwise all fields are required
      if (
        ((lsArr[i].required || curtLs['ls_type'] !== 'Resolution') && ['plain_language_summary', 'bill'].includes(lsArr[i].field) ) &&
        (value === '' || (Array.isArray(value) && value.length === 0))
      ) {
        correctInput = false;
        errorArray.push(lsArr[i].title);
        errors[lsArr[i].field] = 'Required fields (*) cannot be empty!';
      }
    }
    setErrorField(errors);
    setErrorMessage(errorArray);
    return correctInput;
  };

  const displayAllErrorFields = () => {
    if (errorMessage.length > 1) {
      let quoteErrors = errorMessage.slice(0, -1);
      quoteErrors = quoteErrors.map(error => {
        return (
          <React.Fragment key={error}>"<strong>{error}</strong>",</React.Fragment>
        );
      });
      return (
        <>{quoteErrors} and "<strong>{errorMessage.slice(-1)}</strong>"</>
      );
    } else {
      return (
        <> "<strong>{errorMessage[0]}</strong>"</>
      );
    }
  };

  const onDeleteAttachment = (e, ls, field, id) => {
    props.deleteFile(ls, id, field);
    setCurtLs({
      ...curtLs,
      [field]: curtLs[field].filter(item => item.id !== id),
      uploadDeleted: true,
    });
    e.stopPropagation();
  };

  const onDeleteNewAttachment = (e, field, id) => {
    setNewFields({
      ...newFields,
      [field]: newFields[field].filter((f, index) => index !== id),
    });
    e.stopPropagation();
  };

  // Add the selected LSR to report
  const onAddSelectedLSR = selectedLSR => {
    const lsrs = curtLs['overlapping_ls'];
    let hasDuplicate = false;
    for (let i = 0; i < lsrs.length; i++) {
      if (lsrs[i] === selectedLSR) {
        hasDuplicate = true;
        return false;
      }
    }
    if (!hasDuplicate) {
      lsrs.push(selectedLSR);
    }
    setCurtLs(prevState => ({ ...prevState, overlapping_ls: lsrs }));
    return true;
  };

  // Delete the selected LSR to report
  const onDeleteTargetLSR = targetIdx => {
    const lsrs = curtLs['overlapping_ls'];
    let newLSRs = [];
    for (let i = 0; i < lsrs.length; i++) {
      if (i !== targetIdx) {
        newLSRs.push(lsrs[i]);
      }
    }
    setCurtLs(prevState => ({ ...prevState, overlapping_ls: newLSRs }));
  };

  // Send out HTTP request to update the info and close the modal
  const onUpdate = () => {
    let validation = checkValidation(false);
    if (validation) {
      let lsRequest = Object.assign({}, curtLs, {
        bill: newFields['bill'],
        legal_memo: newFields['legal_memo'],
        plain_language_summary: newFields['plain_language_summary'],
        overlapping_ls: curtLs['overlapping_ls'],
      });
      setErrorMessage([]);
      props.sendDocumentsToCM(lsRequest);
      delay()
      props.onClose()
    }
    scrollToTheTop();
  };

  const generateForm = lsRequestFields => {
    const isCMRelated = rolesUnderCouncilMembers.includes(
      props.userProfile.role
    );
    return lsRequestFields.map((ls, idx) => {
      const title = ((ls.required || curtLs['ls_type'] !== 'Resolution') && ['plain_language_summary', 'bill'].includes(ls.field)) ? `${ls.title}*` : ls.title;
      return (
        <div className='mb-3' key={idx} style={{ position: 'relative' }}>
          { curtLs[ls.field] !== undefined && (
            <>
            <label className={`form-label ${styles['ls-title']}`}>
                {title}
                {ls.viewability === 'staffOnly' ? (
                  <span className={styles['not-visible-to-cm']}>
                    &nbsp;(Not visible to CMs)
                  </span>
                ) : (
                  ''
                )}
              {ls.help && (
                <ToolTip
                  id={ls.field}
                  target={ls.field}
                  text={
                    ls.help && typeof ls.help === 'object'
                      ? ls.help[inspirationType]
                      : ls.help
                  }
                />
              )}
              </label>
            </>
          )}
          {( ls.type === "file" &&
            <>
              <input
                className='form-control form-control-lg field-size'
                type='file'
                accept={acceptedFileTypes}
                key={ls.title}
                onChange={e => {
                  let error_messages = [];
                  for (let i = 0; i < e.target.files.length; i++) {
                    // If the file size is more than 250MB do not input
                    if (e.target.files[i].size > 250000000) {
                      error_messages.push(
                        e.target.files[i].name + ' is too large'
                      );
                    }
                  }
                  if (error_messages.length) {
                    e.target.value = null;
                    // setFile_limit_exceeded(ls.field);
                    // setFile_error_message(error_messages.join(', '));
                  } else {
                    let files = e.target.files;

                    // let error = [];
                    for (let i = 0; i < files.length; i++) {
                      files[i].file_name = files[i].name;
                      // error.push( files[i].name + 'is too large');
                      let updatedField = [...newFields[ls.field], files[i]];
                      setNewFields({ ...newFields, [ls.field]: updatedField });
                    }
                  }
                }}
                multiple></input>
              <br />
              {curtLs[ls.field].map((file, index) => (
                <File
                  id={`lsr_old_${ls.field}-${index}`}
                  file={file}
                  getFileAndDownload={props.getFileAndDownload}
                  key={index}
                  onDelete={e =>
                    onDeleteAttachment(e, curtLs, ls.field, file.id)
                  }
                  deletePermission={
                    props.userProfile.permissions.lsRequest_api
                      .change_lsrequest && !isCMRelated
                  }
                />
              ))}
              {newFields[ls.field] &&
                newFields[ls.field].map((file, index) => (
                  <File
                    id={`lsr_new_${ls.field}-${index}`}
                    newUpload={true}
                    file={{ file: file, ...file }}
                    getFileAndDownload={props.getFileAndDownload}
                    key={index}
                    onDelete={e => onDeleteNewAttachment(e, ls.field, index)}
                    deletePermission={true}
                  />
                ))}
              {errorField[ls.field] && (
                <p className={styles['warning-message']}>
                  {errorField[ls.field]}
                </p>
              )}
              <br />
            </>
          )}
          {ls.field === 'overlapping_ls' && 
          <div className='mb-3'>
            <TagsDisplay
              allowNew={true}
              className={
                !errorField[ls.field]
                  ? styles['input-text-area']
                  : styles['input-text-area-warning']
              }
              currentList={curtLs[ls.field]}
              dropdownList={[]}
              inputTitle={'Change status of the following LSRs:'}
              noList={true}
              onAddTarget={onAddSelectedLSR}
              onDeleteTarget={onDeleteTargetLSR}
              param={'ls_number'}
              placeholder={'(e.g., 5667)'}
              warningMessage={'No LSR has been selected'}
            />
            {errorField[ls.field] && (
              <p className={styles['warning-message']}>
                {errorField[ls.field]}
              </p>
            )}
          </div>
          }
        </div>
      );
    });
  };

  return (
    <>
      {/* UPDATE LSR HEADER */}
      <div
        className={`d-flex justify-content-between align-items-center p-3 border-bottom fs-5 fw-bolder
        ${
          props.updateTargetLsStatus === 'success'
            ? `${styles['update-ls-request-header-container']} ${styles['success']}`
            : styles['update-ls-request-header-container']
        }`}>
        <span>Send Documents to CM</span>
        <button
          type='button'
          className='btn-close p-2 rounded-3'
          onClick={props.onClose}
          aria-label='Close'></button>
      </div>
      {/* END UPDATE LSR HEADER */}

      {/* UPDATE LSR FORM BODY */}
      <div
        className={`d-flex flex-column align-items-center overflow-auto p-4
         ${
           props.updateTargetLsStatus === 'success'
             ? `${styles['update-ls-request-body']} ${styles['success']}`
             : `${styles['update-ls-request-body']}`
         }`}>
        {/* FAIL MESSAGE */}
        {props.updateTargetLsStatus === 'fail' && (
          <div
            className={`alert alert-danger ${styles['success-create-message']}`}
            role='alert'>
            <p>{props.errorMessage}</p>
          </div>
        )}
        {/* END FAIL MESSAGE */}

        {/* ERROR MESSAGE */}
        {errorMessage.length > 0 && (
          <div
            className={`alert alert-danger ${styles['error-message']}`}
            role='alert'>
            <div>
              <ExclamationPointDiamondIcon />
            </div>
            <div>
              {errorMessage.length < 4 && (
                <>
                  There was an error in the following field(s):&nbsp;
                  {displayAllErrorFields()}.
                </>
              )}
            </div>
          </div>
        )}
        {/* END ERROR MESSAGE */}

        {/* UPDATE LSR SUCCESS MESSAGE */}
        {props.updateTargetLsStatus === 'success' && (
          <div className={styles['success-message-container']}>
            <div
              className={`alert alert-success ${styles['success-create-message']}`}
              role='alert'>
              <p>
                LSR #<b>{curtLs.ls_number}</b> has been updated!
              </p>
              <p>&nbsp;Page will refresh shortly.</p>
            </div>
          </div>
        )}
        {/* END UPDATE LSR SUCCESS MESSAGE */}

        <form className='row w-100 p-0'>
          <div className='col'>{generateForm(filteredFields)}</div>
        </form>
      </div>
      {/* END UPDATE LSR FORM BODY */}
      {/* UPDATE LSR FORM FOOTER */}

      <div className='d-flex align-items-center justify-content-end border-top p-3'>
        {props.updateTargetLsStatus !== 'success' && (
          <button className='cancel-button-text' onClick={props.onClose}>
            Cancel
          </button>
        )}
        <button
          className='submit-button'
          disabled={
            props.updateTargetLsStatus === 'working...' ||
            props.updateTargetLsStatus === 'success'
          }
          onClick={onUpdate}>
          {props.updateTargetLsStatus === 'working...' && (
            <span
              className='spinner-border spinner-border-sm'
              role='status'
              aria-hidden='true'></span>
          )}{' '}
          Send Documents to CM
        </button>
      </div>
      {/* END UPDATE LSR FORM FOOTER */}
      {props.updateTargetLsStatus !== 'success' && (
        <div className={styles['update-pop-up-container']}></div>
      )}
    </>
  );
};

const mapStateToProps = state => {
  return {
    allUserList: state.userReducer.allUserList,
    userProfile: state.userReducer.userProfile,
    userList: state.userReducer.userList,
    updateTargetLs: state.lsRequestsReducer.updateTargetLs,
    updateTargetLsStatus: state.lsRequestsReducer.updateTargetLsStatus,
    errorMessage: state.lsRequestsReducer.errorMessage,
  };
};

const mapDispatchToProps = {
  sendDocumentsToCM,
  getFileAndDownload,
  deleteFile,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendToCMPopup);
